/*
* @描述: 报价单分享弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-14 17:46:35
*/
<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            custom-class="custom-share-dialog"
            title="分享"
            width="520px">
        <div class="ta_c">
            <p class="quotation_title">【{{ quotation_title }}】</p>
            <div class="copy_link_wrap">
                <el-link :underline="false" type="primary">{{ copyLink }}</el-link>
            </div>
            <el-button type="primary" @click="handleClickCopyLink">复制链接给客户</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name: "",
        data() {
            return {
                copyLink: '',
                userName: "",
                phone: "",
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            quotation_key: {
                type: String,
                default: '',
            },
            quotation_title: {
                type: String,
                default: '',
            }
        },
        created() {
            if (this.quotation_key) {
                this.userName = this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.name;
                const phone = this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.phone;
                this.phone = phone.substr(-4);
                const domain = window.location.protocol + "//" + window.location.host;
                this.copyLink = `${domain}/#/quotation/share?key=${this.quotation_key}&name=${this.userName}&phone=${this.phone}`;
            }
        },
        mounted() {
        },
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            handleClickCopyLink() {
                const textToCopy = this.copyLink;
                const textarea = document.createElement("textarea");
                textarea.value = textToCopy;
                document.body.appendChild(textarea);
                // 选中文本并复制
                textarea.select();
                document.execCommand("copy");
                // 移除临时元素
                document.body.removeChild(textarea);
                this.$message.success("链接已复制！");
            },
        },
    }
</script>
<style lang="scss" scoped>
    .quotation_title {
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        color: #333333;
    }

    .copy_link_wrap {
        text-align: center;
        margin: 16px 0 60px;
    }
</style>